import { combineReducers } from 'redux';
export const loadUserInfoState = {
    userInfo: null,
    isLoading: false,
    error: null,
};
const loadUserInfoReducer = (state = loadUserInfoState, action) => {
    switch (action.type) {
        case 'OLY_LOAD_USER_INFO':
            return {
                ...loadUserInfoState,
                isLoading: true,
            };
        case 'OLY_LOAD_USER_INFO_SUCCESS':
            return {
                ...loadUserInfoState,
                userInfo: action.payload.userInfo,
            };
        case 'OLY_LOAD_USER_INFO_ERROR':
            return {
                ...loadUserInfoState,
                error: action.payload.error,
            };
        case 'OLY_LOAD_USER_INFO_RESET':
            return loadUserInfoState;
        default:
            return state;
    }
};
export const editUserClientState = {
    success: null,
    isLoading: false,
    error: null,
};
const editUserClientReducer = (state = editUserClientState, action) => {
    switch (action.type) {
        case 'OLY_EDIT_USER_CLIENT':
            return {
                ...editUserClientState,
                isLoading: true,
            };
        case 'OLY_EDIT_USER_CLIENT_SUCCESS':
            return {
                ...editUserClientState,
                success: true,
            };
        case 'OLY_EDIT_USER_CLIENT_ERROR':
            return {
                ...editUserClientState,
                error: action.payload.error,
            };
        case 'OLY_EDIT_USER_CLIENT_RESET':
            return editUserClientState;
        default:
            return state;
    }
};
export const editUserInfoState = {
    editedUserId: null,
    isLoading: false,
    error: null,
};
const editUserInfoReducer = (state = editUserInfoState, action) => {
    switch (action.type) {
        case 'OLY_EDIT_USER_INFO':
            return {
                ...editUserInfoState,
                isLoading: true,
            };
        case 'OLY_EDIT_USER_INFO_SUCCESS':
            return {
                ...editUserInfoState,
                editedUserId: action.payload.editedUserId,
            };
        case 'OLY_EDIT_USER_INFO_ERROR':
            return {
                ...editUserInfoState,
                error: action.payload.error,
            };
        case 'OLY_EDIT_USER_INFO_RESET':
            return editUserInfoState;
        default:
            return state;
    }
};
export const deleteUserInfoGroupState = {
    deletedUserGroupId: null,
    isLoading: false,
    error: null,
};
const deleteUserInfoGroupReducer = (state = deleteUserInfoGroupState, action) => {
    switch (action.type) {
        case 'OLY_DELETE_USER_INFO_GROUP':
            return {
                ...deleteUserInfoGroupState,
                isLoading: true,
            };
        case 'OLY_DELETE_USER_INFO_GROUP_SUCCESS':
            return {
                ...deleteUserInfoGroupState,
                deletedUserGroupId: action.payload.deletedUserGroupId,
            };
        case 'OLY_DELETE_USER_INFO_GROUP_ERROR':
            return {
                ...deleteUserInfoGroupState,
                error: action.payload.error,
            };
        case 'OLY_DELETE_USER_INFO_GROUP_RESET':
            return deleteUserInfoGroupState;
        default:
            return state;
    }
};
export const deleteUserInfoClientState = {
    deletedUserClientId: null,
    isLoading: false,
    error: null,
};
const deleteUserInfoClientReducer = (state = deleteUserInfoClientState, action) => {
    switch (action.type) {
        case 'OLY_DELETE_USER_INFO_CLIENT':
            return {
                ...deleteUserInfoClientState,
                isLoading: true,
            };
        case 'OLY_DELETE_USER_INFO_CLIENT_SUCCESS':
            return {
                ...deleteUserInfoClientState,
                deletedUserClientId: action.payload.deletedUserClientId,
            };
        case 'OLY_DELETE_USER_INFO_CLIENT_ERROR':
            return {
                ...deleteUserInfoClientState,
                error: action.payload.error,
            };
        case 'OLY_DELETE_USER_INFO_CLIENT_RESET':
            return deleteUserInfoClientState;
        default:
            return state;
    }
};
export const deleteUserState = {
    deletedUserId: null,
    isLoading: false,
    error: null,
};
const deleteUserReducer = (state = deleteUserState, action) => {
    switch (action.type) {
        case 'OLY_DELETE_USER':
            return {
                ...deleteUserState,
                isLoading: true,
            };
        case 'OLY_DELETE_USER_SUCCESS':
            return {
                ...deleteUserState,
                deletedUserId: action.payload.deletedUserId,
            };
        case 'OLY_DELETE_USER_ERROR':
            return {
                ...deleteUserState,
                error: action.payload.error,
            };
        case 'OLY_DELETE_USER_RESET':
            return deleteUserState;
        default:
            return state;
    }
};
export const userInfoState = {
    loadUserInfo: loadUserInfoState,
    editUserInfo: editUserInfoState,
    editUserClient: editUserClientState,
    deleteUserInfoGroup: deleteUserInfoGroupState,
    deleteUserInfoClient: deleteUserInfoClientState,
    deleteUser: deleteUserState,
};
export default combineReducers({
    loadUserInfo: loadUserInfoReducer,
    editUserInfo: editUserInfoReducer,
    editUserClient: editUserClientReducer,
    deleteUserInfoGroup: deleteUserInfoGroupReducer,
    deleteUserInfoClient: deleteUserInfoClientReducer,
    deleteUser: deleteUserReducer,
});
